// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1749741133635
      var cssReload = require("/var/www/resources/calmit-app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  